import {
  INIT_APPLICATION,
  INIT_APPLICATION_SUCCESS,
  INIT_APPLICATION_FAILURE,
  SWITCH_ACCOUNT_TYPE_SUCCESS
} from './initActions';

import { CREATE_TOKEN_SUCCESS } from '../signin/signinActions';
import { CREATE_CUSTOMER_SUCCESS } from '../signup/signupActions';
import { CREATE_COURSE_SUCCESS, CANCEL_COURSE } from '../course/courseActions';

const initialState = {
  currentUser: {},
  currentCourse: null,
  isLoggingIn: false,
  loading: true,
  isStockHandled: false,
  currentAccountInformations: {}
};

const initReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_APP':
      return {
        ...state,
        isLoggingIn: false,
        currentUser: {},
        currentCourse: null,
        currentAccountInformations: {}
      };
    case CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        isLoggingIn: true,
        currentAccountInformations: action.payload
      };
    case CREATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        isLoggingIn: true
      };
    case INIT_APPLICATION:
      return {
        ...state,
        loading: true
      };
    case INIT_APPLICATION_SUCCESS:
      return {
        ...state,
        currentUser: action.payload.user,
        currentCourse: action.payload.course,
        isStockHandled: action.payload.isStockHandled,
        productBarcode: action.payload.barcodeValues,
        stock: action.payload.stock,
        usedCarrier: action.payload.usedCarrier,
        isLoggingIn: true,
        loading: false
      };
    case INIT_APPLICATION_FAILURE:
      return {
        ...state,
        loading: false
      };
    case CREATE_COURSE_SUCCESS:
      return {
        ...state,
        currentCourse: {
          pickupAddress: action.payload.pickupAddress,
          id: action.payload.courseId
        }
      };
    case SWITCH_ACCOUNT_TYPE_SUCCESS:
      return {
        ...state,
        currentAccountInformations: {
          ...state.currentAccountInformations,
          accountType: action.payload
        }
      };
    case CANCEL_COURSE:
      return {
        ...state,
        currentCourse: null
      };
    default:
      return state;
  }
};

export default initReducer;
